<script>
  import Constants from "./Constants";
  import Calculator from "./components/Calculator.svelte";
  import LevelUp from "./components/LevelUp.svelte";
  import StatusView from "./components/StatusView.svelte";
  import Header from "./components/Header.svelte";
  import { onMount } from "svelte";
  import { BigNumber } from "bignumber.js";

  let level = 1;
  let exp = 0;
  let viewLevelUpEffect;
  let calculator;

  onMount(async () => {
    calculator.updateLevel(level);
  });

  /**
   * 経験値追加
   * @param e 経験値
   */
  const addExp = (e) => {
    exp += e.detail.exp;
    if (Constants.EXP_TABLE[level] <= exp) {
      level++;
      viewLevelUpEffect();
      calculator.updateLevel(level);
    }
  };
</script>

<main>
  <Header />
  <div class="main-container">
    <LevelUp bind:viewLevelUpEffect {level} />
    <StatusView {exp} {level} />
    <div class="sub-container">
      <Calculator bind:this={calculator} {level} on:addExp={addExp} />
    </div>
  </div>
</main>

<style>
  main {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .main-container {
    margin: 0 auto;
    width: 95%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    flex-grow: 1;
  }
  .sub-container {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-grow: 1;
  }
</style>
